import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

library.add(faChevronRight);

Vue.component('font-awesome-icon', FontAwesomeIcon);
